import * as api from "../api";

export const sendMessage = async (messageFormData) => {
  try {
    const { data } = await api.sendMessage(messageFormData);

    return data;
  } catch (error) {
    return error;
  }
};
export const getRequests = async () => {
  try {
    const { data } = await api.getRequests();

    return data;
  } catch (error) {
    return { requestError: error.response.data };
  }
};

export const setStatus = async (data) => {
  try {
    await api.setStatus(data);
  } catch (error) {
    return error.response.data;
  }
};

export const statusCount = async () => {
  try {
    const { data } = await api.statusCount();
    return data;
  } catch (error) {
    return error;
  }
};
